import { ShortlistWithScores } from "PFApp/components/resource_table_toggle/hooks/use_shortlist_items";
import { ShortlistStateLabel } from "PFApp/components/role_profile_action_buttons/parts/shortlist_state_label";
import { useShortlistsInvalidate } from "PFCore/hooks/queries/shortlists/use_shortlists_invalidate";
import { Activity, Id } from "PFTypes";

import css from "./shortlist_state_cell.module.scss";

type ShortlistStateCellProps = {
  activity: Activity;
  shortlist: ShortlistWithScores;
  onShortlistUndo?: (shortlistId: Id) => void;
};

export const ShortlistStateCell = ({ activity, shortlist, onShortlistUndo }: ShortlistStateCellProps) => {
  const { invalidateShortlists, invalidateRankedShortlists } = useShortlistsInvalidate();

  const handleUndoClick = () => {
    invalidateShortlists(activity.id);
    invalidateRankedShortlists(activity.id);
    onShortlistUndo?.(shortlist.id);
  };

  return (
    <div className={css.root}>
      <ShortlistStateLabel
        role={activity}
        shortlist={shortlist}
        profile={shortlist.profile}
        onUndoSuccess={handleUndoClick}
      />
    </div>
  );
};
